import Header from '../components/Header';
import Footer from '../components/Footer';

const sections = [
	{
		id: 'welcome',
		title: 'Welcome',
		content: (
			<p className="text-slate-600 leading-relaxed">
				Welcome to Viance. By accessing our website or engaging our services, you agree to be bound by these Terms &amp; Conditions. If you do not agree, please discontinue use of our site and services.
			</p>
		),
	},
	{
		id: 'services-overview',
		title: '1. Services Overview',
		content: (
			<div className="space-y-3">
				<p className="text-slate-600 leading-relaxed">
					VIANCE HEALTHCARE SYSTEMS PRIVATE LIMITED provides web development, mobile application development, database management, and technology solutions for healthcare systems and modern service businesses.
				</p>
				<ul className="list-disc pl-6 space-y-1 text-slate-600">
					<li>Custom software &amp; platform engineering</li>
					<li>Web &amp; mobile application development</li>
					<li>Database design, management &amp; optimisation</li>
					<li>Healthcare technology solutions</li>
					<li>Technology / architecture consulting &amp; strategic advisory</li>
					<li>Support, enhancement &amp; optimisation services</li>
				</ul>
			</div>
		),
	},
	{
		id: 'project-engagement',
		title: '2. Project Engagement',
		content: (
			<p className="text-slate-600 leading-relaxed">
				Engagements begin with a mutually executed Statement of Work (SoW) or Master Services Agreement (MSA) defining scope, deliverables, acceptance criteria, success metrics, fees, timelines and assumptions. Scope adjustments require written change orders which may impact cost and schedule. We reserve the right to decline or discontinue services for misuse, non‑payment, unlawful activity, or reputational risk.
			</p>
		),
	},
	{
		id: 'intellectual-property',
		title: '3. Intellectual Property Rights',
		content: (
			<div className="space-y-3">
				<p className="text-slate-600 leading-relaxed">Unless otherwise specified in the SoW:</p>
				<ul className="list-disc pl-6 space-y-1 text-slate-600">
					<li>Upon full and final payment, ownership of bespoke deliverables (code, UI assets, documentation) transfers to the client.</li>
					<li>Viance retains all rights to pre‑existing &amp; generic IP including internal frameworks, accelerators, libraries, tooling, architectural blueprints and generalised know‑how.</li>
					<li>We may reuse non‑confidential learnings, generalised techniques and anonymised patterns.</li>
					<li>Showcasing name, logo, or case study requires your prior consent (not unreasonably withheld).</li>
				</ul>
			</div>
		),
	},
	{
		id: 'client-responsibilities',
		title: '4. Client Responsibilities',
		content: (
			<ul className="list-disc pl-6 space-y-1 text-slate-600">
				<li>Provide timely decisions, feedback and approvals.</li>
				<li>Supply accurate data, credentials &amp; environment access.</li>
				<li>Ensure all furnished materials are lawfully obtained &amp; licensed.</li>
				<li>Designate a single empowered primary contact.</li>
				<li>Adhere to security instructions &amp; environment readiness.</li>
			</ul>
		),
	},
	{
		id: 'payment-terms',
		title: '5. Payment Terms',
		content: (
			<ul className="list-disc pl-6 space-y-1 text-slate-600">
				<li>Advance / deposit due prior to kickoff (unless otherwise agreed).</li>
				<li>Milestone or time &amp; materials billing per SoW cadence.</li>
				<li>Invoices payable within 15 (fifteen) days of date of issue.</li>
				<li>Late payments may suspend delivery; interest may accrue as permitted by law.</li>
				<li>Taxes, duties, withholding or bank charges borne by client except where explicitly stated.</li>
			</ul>
		),
	},
	{
		id: 'confidentiality',
		title: '6. Confidentiality',
		content: (
			<p className="text-slate-600 leading-relaxed">
				Each party agrees to protect the other's Confidential Information using at least reasonable care and use it solely for fulfilling contractual obligations. Exclusions include information that is public, already known without restriction, independently developed, or lawfully obtained from a third party. Legal disclosures allowed with prompt notice. Survives termination.
			</p>
		),
	},
	{
		id: 'warranties',
		title: '7. Warranties &amp; Disclaimer',
		content: (
			<p className="text-slate-600 leading-relaxed">
				We warrant services will be performed in a professional and workmanlike manner following generally accepted industry standards. EXCEPT FOR EXPRESS WARRANTIES HEREIN, SERVICES AND DELIVERABLES ARE PROVIDED "AS IS". WE DISCLAIM ALL IMPLIED WARRANTIES INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE &amp; NON‑INFRINGEMENT.
			</p>
		),
	},
	{
		id: 'limitation-of-liability',
		title: '8. Limitation of Liability',
		content: (
			<p className="text-slate-600 leading-relaxed">
				To the maximum extent permitted by law, our cumulative liability for any claim shall not exceed the fees paid (or payable) for the specific service giving rise to the claim in the 3 months preceding the event. No liability for indirect, consequential, incidental, exemplary, special or lost profit damages even if advised of the possibility.
			</p>
		),
	},
	{
		id: 'termination',
		title: '9. Termination',
		content: (
			<p className="text-slate-600 leading-relaxed">
				Either party may terminate for material breach not cured within 30 days of written notice. Upon termination: (a) client pays all fees for work performed and approved expenses; (b) we deliver accepted deliverables &amp; in‑progress work (as‑is) after payment of outstanding amounts; (c) sections relating to IP ownership (as applicable), confidentiality, payment, limitation of liability, dispute resolution and governing law survive.
			</p>
		),
	},
	{
		id: 'force-majeure',
		title: '10. Force Majeure',
		content: (
			<p className="text-slate-600 leading-relaxed">
				No party is liable for delays or failures caused by events beyond reasonable control (natural disasters, pandemics, acts of government, internet outages at scale, war, terrorism, labour disturbances, supply chain failures). The affected party will notify and mitigate in good faith.
			</p>
		),
	},
	{
		id: 'dispute-resolution',
		title: '11. Dispute Resolution',
		content: (
			<p className="text-slate-600 leading-relaxed">
				The parties will first attempt informal good‑faith negotiation. If unresolved within 30 days, disputes (excluding injunctive relief claims) shall be finally settled by arbitration in Pune, Maharashtra under the Arbitration &amp; Conciliation Act, 1996. Proceedings are confidential; the award is enforceable in any competent court.
			</p>
		),
	},
	{
		id: 'use-of-website',
		title: '12. Use of Website',
		content: (
			<p className="text-slate-600 leading-relaxed">
				You agree not to misuse the site — no unlawful, infringing, or disruptive activity, no automated scraping (except search indexing), no reverse engineering of protected areas, and no circumvention of security controls.
			</p>
		),
	},
	{
		id: 'privacy-policy',
		title: '13. Privacy Policy',
		content: (
			<p className="text-slate-600 leading-relaxed">
				Data collection &amp; processing practices are described in our{' '}
				<a className="text-cyan-600 hover:underline" href="/privacy">Privacy Policy</a>. By using our services you also accept that policy.
			</p>
		),
	},
	{
		id: 'changes',
		title: '14. Changes to Terms',
		content: (
			<p className="text-slate-600 leading-relaxed">
				We may update these Terms to reflect operational, legal, or regulatory changes. Material updates will be signalled via site notice or communication. Continued use after the effective date constitutes acceptance.
			</p>
		),
	},
	{
		id: 'governing-law',
		title: '15. Governing Law',
		content: (
			<p className="text-slate-600 leading-relaxed">
				These Terms are governed by the laws of Maharashtra, India, excluding conflict of law principles. Venue for any permitted court actions: Pune, India.
			</p>
		),
	},
	{
		id: 'contact',
		title: '16. Contact Information',
		content: (
			<div className="space-y-2 text-slate-600">
				<p className="font-semibold text-slate-800">VIANCE HEALTHCARE SYSTEMS PRIVATE LIMITED</p>
				<p>Sulochana Apartments, Income Tax Lane, Pune – 411004, Maharashtra, India</p>
				<p>
					Email:{' '}
					<a className="text-cyan-600 hover:underline" href="mailto:admin@viance.co.in">
						admin@viance.co.in
					</a>
				</p>
				<p>
					Phone:{' '}
					<a className="text-cyan-600 hover:underline" href="tel:+919823272353">
						+91 9823272353
					</a>
				</p>
			</div>
		),
	},
];

function TermsAndConditions() {
	return (
		<div className="min-h-screen bg-gradient-to-b from-slate-50 via-slate-100 to-slate-100 text-slate-900">
			<Header />
			<main className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
				{/* Page header */}
				<div className="mb-10">
					<span className="inline-block rounded-full bg-cyan-100 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-cyan-700">
						Legal
					</span>
					<h1 className="mt-4 text-4xl font-extrabold tracking-tight text-slate-900">
						Terms &amp; Conditions
					</h1>
					<p className="mt-3 max-w-2xl text-slate-600">
						Comprehensive legal terms governing access to Viance services and digital properties.
					</p>
					<p className="mt-2 text-sm text-slate-400">Last updated: 2026</p>
				</div>

				{/* Table of contents */}
				<nav className="mb-10 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
					<h2 className="mb-3 text-sm font-semibold uppercase tracking-widest text-cyan-700">Contents</h2>
					<ol className="space-y-1 text-sm text-slate-600">
						{sections.map((s) => (
							<li key={s.id}>
								<a href={`#${s.id}`} className="hover:text-cyan-600 transition-colors">
									{s.title}
								</a>
							</li>
						))}
					</ol>
				</nav>

				{/* Sections */}
				<div className="space-y-10 rounded-2xl bg-white p-8 shadow-sm ring-1 ring-slate-200">
					{sections.map((s, i) => (
						<section key={s.id} id={s.id} className={i !== 0 ? 'border-t border-slate-100 pt-8' : ''}>
							<h2
								className="mb-4 text-xl font-bold text-slate-900"
								dangerouslySetInnerHTML={{ __html: s.title }}
							/>
							{s.content}
						</section>
					))}
				</div>
			</main>
			<Footer />
		</div>
	);
}

export default TermsAndConditions;
